// src/router/tarefaTipo.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const tarefaTiposBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Tipo Tarefa',
        to: 'Tipos de Tarefa'
    }
]

export default [
    {
        path: '/tarefa-tipos',
        name: 'Tipos de Tarefa',
        component: () => import('@/views/TarefaTipos/TarefaTipoListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Tipos de Tarefa',
            breadcrumb: tarefaTiposBreadCrumb
        },
    },
    {
        path: '/tarefa-tipos/novo',
        name: 'NovoTipoTarefa',
        component: () => import('@/views/TarefaTipos/NovoTarefaTipoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Nova Tarefa',
            breadcrumb: [
                ...tarefaTiposBreadCrumb,
                {
                    label: 'Nova Tarefa',
                    to: 'NovoTipoTarefa'
                }
            ]
        }
    },
    {
        path: '/tarefa-tipos/:id/edit',
        name: 'TarefaTipoEdit',
        component: () => import('@/views/TarefaTipos/NovoTarefaTipoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Tipo da Tarefa',
            breadcrumb: [
                ...tarefaTiposBreadCrumb,
                {
                    label: 'Nova Tarefa',
                    to: 'NovoTipoTarefa'
                }
            ]
        }
    }

];
